import React from "react";
import Escuela from "../images/escuela.png";
import Escuela1 from "../images/escuela1.png";
import Escuelafondo from "../images/fondoescuela.png";
import Tablero from "../images/tablero.png";
import { Helmet } from "react-helmet";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  actividadFondo: {
    backgroundImage: "url(" + Escuelafondo + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    paddingBottom: 40,
    paddingTop: 20,
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
      paddingLeft: 40,
    },
    "& h1": {
      paddingLeft: 40,
    },
    marginBottom: "4em",
    [theme.breakpoints.down("md")]: {
      "& p": {
        paddingLeft: 20,
      },
      "& h1": {
        paddingLeft: 20,
      },
    },
    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      backgroundPosition: "80%",
      minHeight: 800,
    },
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
}));

const Lamina3 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 3: La importancia de la escuela"
        meta={[
          {
            property: "og:title",
            content: "Lámina 3: La importancia de la escuela",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "La escuela es un lugar donde aprendemos a desarrollarnos como personas.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="3" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={8} md={8} xs={12}>
            <Title title="LA IMPORTANCIA DE LA ESCUELA" color="primary" />
            <p>
              La escuela es un espacio de convivencia en el que compartimos
              experiencias y aprendizajes con profesores, compañeros y
              trabajadores del colegio.
            </p>
            <p style={{ color: "#00a77e" }}>
              <strong>
                Pero no todas las escuelas son iguales. Las que encontramos en
                todo el territorio del Perú son diversas.
              </strong>
            </p>
          </Grid>
          <Grid item lg={4} md={4} xs={12}>
            <img src={Escuela} alt="Escuela" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="primary" />
        <p>
          <strong>Observa las imágenes.</strong>
        </p>
        <img src={Escuela1} alt="Escuela" />
        <div className={classes.actividad}>
          <p>Ahora dibuja tu escuela o algo que te guste de ella.</p>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo}>
          <TitleSmall title="OTRAS FORMAS DE APRENDER" color="primary" />
          <p>
            Normalmente, asistimos al local de la escuela, pero también existen
            espacios de aprendizaje a distancia, a través de Internet, la
            televisión, la radio o los periódicos, que podemos aprovechar desde
            casa.
          </p>
          <p style={{ color: "#0072bc" }}>
            <strong>
              De esa manera, podemos permanecer en casa y continuar aprendiendo
              para estar mejor preparados al volver a las clases presenciales
              cuando sea seguro.
            </strong>
          </p>
        </div>
      </Container>
      <Container maxWidth="md">
        <Grid
          container
          className={classes.contentLamina}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} xs={12}>
            <img src={Tablero} alt="Nuevos habitos" />
          </Grid>
          <Grid item lg={6} xs={12}>
            <Actividad color="primary" />
            <p>
              <strong>
                Tomando en cuenta tu experiencia en estas últimas semanas
              </strong>{" "}
              , ¿qué otras recomendaciones les darías a estudiantes como tú para
              seguir aprendiendo desde casa? Puedes escribir un párrafo o grabar
              un audio o un video.
            </p>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-3.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 3: La importancia de la escuela'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Deberes y rutinas en casa"
        anteriorEnlace="/lamina-1-2"
        siguiente="Mi localidad"
        siguienteEnlace="/lamina-1-4"
      />
    </>
  );
};

export default Lamina3;
